
const roles = [
  {
    "id": "1b57e404-b945-43f3-a13b-9f5378184f10",
    "name": "Mitarbeiter",
    },
    {
      "id": "97e6d8bb-fb34-4b8a-a069-2e93ced54739",
      "name": "Reporter",
    },
    {
      "id": "f4b1b151-6975-4b8f-9d23-9fb2ba8877c6",
      "name": "HR-Manager",
    },
    {
      "id": "0333ceb9-feed-4472-9bfa-e41de4dff769",
      "name": "Maintainer",
    },
    {
      "id": "f3e0f40a-fbe5-4fb5-9ace-d055ca4f5f81",
      "name": "Administrator",
    },
]

export default roles
